import React from "react";
import Homesection4Card from "./Homesection4Card";
// import Homesection4Card1 from "./Homesection4Card1";


const Homesection4 = () => {
  return (
    <div id="facility">
    <div className="third mt-20  lg:pt-16 lg:pb-20">
      <div className="institution text-center lg:px-80">
        <h1 className="p-11 font-serif text-4xl text-blue-900  lg:text-8xl">
          What <a className="underline decoration-orange-700"> we </a> offer
        </h1>
        {/* <p className="mx-5 text-lg font-semibold leading-8">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Omnis sed et
          necessitatibus ipsam sunt temporibus aspernatur voluptatem ad,
        </p> */}
      </div>
      <div className="flex h-fit w-screen justify-center lg:pt-24">
        <div className="mx-14 hidden lg:block lg:w-[45%]">
          <img
            className="ml-14 h-full lg:w-full lg:h-[80%]"
            src="https://us.123rf.com/450wm/lembergvector/lembergvector1803/lembergvector180300144/98267688-school-education-flat-info-graphics-icons-in-circle-color-concept-illustration-for-school-cover.jpg?ver=6"
            alt=""
          />
        </div>
        <div className="w-screen flex-col  px-12 pt-24  lg:flex lg:w-2/4 lg:pt-0">
          <Homesection4Card row="upper" /> 
          <Homesection4Card row="lower" />
        </div>
      </div>
    </div>
    </div>
  );
};

export default Homesection4;
